import type {Tab} from 'shells/control-bar/page-control-bar';

import {useGetSetting} from '../../use-get-setting';
import {useUpdateSetting} from '../../use-update-setting';

export function useAugmentTabWithNewFeatureNotification(tab: Tab, settingName: string) {
    const {setting, isLoading} = useGetSetting({
        settingName,
    });
    const updateSetting = useUpdateSetting();

    const onClick = () => {
        if (setting && !setting.value) {
            updateSetting({
                settingName,
                value: true,
            });
        }
    };

    return {
        ...tab,
        onClick,
        badgeColor: setting && !setting.value && !isLoading ? 'orange' : undefined,
    };
}
